import React from "react";

export function Brand({ size = "md" }) {
  const cls = size === "lg"
    ? "font-display font-black text-5xl sm:text-6xl tracking-tighter"
    : "font-display font-black text-lg tracking-tight";
  return (
    <span className={`${cls} inline-flex items-baseline leading-none`} data-testid="brand">
      <span>TRYSTOMA</span>
      <span className="text-[#7C3AED]">TIC</span>
      <span className="inline-block w-1.5 h-1.5 bg-[#7C3AED] ml-1 self-end mb-1" />
    </span>
  );
}
